export default "__VITE_ASSET__BFPwgnlL__"